import { buttonReset } from 'components/Button/Button.styles'
import { styled } from 'stitches.config'

export const BlogPaginationRoot = styled('nav', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '$3',
  paddingBottom: '$8',
  paddingTop: '$10',
})

export const PageLinksList = styled('ul', {
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
  listStyle: 'none',
  padding: 0,
  margin: 0,
})

export const PageLink = styled('a', {
  ...buttonReset,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  size: '$4',
  borderRadius: '$2',
  border: '1px solid $tertiary-300',
  color: '$tertiary-400',
  cursor: 'pointer',

  variants: {
    isActive: {
      true: {
        border: '1px solid $primary-500',
        color: '$primary-500',
        fontWeight: 'bold',
      },
    },
  },
})

export const Ellipsis = styled('span', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  size: '$4',
  color: '$tertiary-400',
})

export const NavigationLink = styled('a', {
  ...buttonReset,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  size: '$4',
  borderRadius: '$2',
  border: '1px solid $tertiary-300',
  color: '$tertiary-400',
  cursor: 'pointer',

  variants: {
    isDisabled: {
      true: {
        border: '1px solid $tertiary-300',
        color: '$tertiary-300',
        pointerEvents: 'none',
      },
    },
  },
})
